"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE = void 0;
var SERVICE;
(function (SERVICE) {
    // 연계 서비스
    SERVICE["ST331"] = "ST331";
    SERVICE["SD332"] = "SD332";
    SERVICE["ST333"] = "ST333";
    SERVICE["SH334"] = "SH334";
    SERVICE["ST335"] = "ST335";
})(SERVICE = exports.SERVICE || (exports.SERVICE = {}));
